// extracted by mini-css-extract-plugin
var _1 = "ProjectActionsPopup_icon__Dghr8";
export { _1 as "icon" }
